import { useMutation } from 'react-apollo'
import { UpdatePackage } from '../../../graphql/packages/mutations'

/**
 *  Updates a package (aka orderset)

 * @returns Package
 */

export const useMutationUpdatePackageApi = () => {
  const [updatePackage, { data: updatePackageData, error: updatePackageError, loading: updatePackageLoading }] = useMutation(UpdatePackage, {})

  return [
    updatePackage,
    {
      data: updatePackageData,
      error: updatePackageError,
      loading: updatePackageLoading,
    },
  ] as const
}
